<template>
  <div class="form-item refusal-checkbox span-1">
    <label class="checkbox-label">
      <input
          type="checkbox"
          :checked="modelValue"
          @change="onChange"
      >
      <span class="fake-checkbox"></span>
      <span class="checkbox-name">{{ label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxFilter',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Чекбокс',
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onChange(event) {
      this.$emit('update:modelValue', event.target.checked);
    },
  },
};
</script>